import { render, staticRenderFns } from "./NewCalender.vue?vue&type=template&id=c2fc7fd0&scoped=true&"
import script from "./NewCalender.vue?vue&type=script&lang=js&"
export * from "./NewCalender.vue?vue&type=script&lang=js&"
import style0 from "./NewCalender.vue?vue&type=style&index=0&id=c2fc7fd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fc7fd0",
  null
  
)

export default component.exports